import * as angular from "angular";

export const ngmodule = angular.module("app", [
    'abo-theme',
    'ui.router',
    'restangular',
    'LocalStorageModule',
    'ngLetterAvatar',
    'ui.router.modal',
    'angularFileUpload',
    'ngMessages',
    'gettext',
    'permission',
    'permission.ui',
    'angular.filter',
    'ng.deviceDetector',
    'matchMedia', 
    'ngFileSaver',
    'infinite-scroll',
    'ngclipboard'
]);

const BLANK_MODULE = {
  states: [],
  components: {},
  directives: {},
  services: {},
  filters: {},
  factories: {},
  configBlocks: [],
  runBlocks: []
};

/**
 * Register each app module's states, directives, components, filters, services,
 * and config/run blocks with the `ngmodule`
 *
 * @param ngModule the `angular.module()` object
 * @param appModule the feature module consisting of components, states, services, etc
 */
export const loadNg1Module = (ngModule, appModule) => {

  let module = Object.assign({}, BLANK_MODULE, appModule);

  ngModule.config(['$stateProvider', $stateProvider => module.states.forEach(state => $stateProvider.state(state))]);

  Object.keys(module.components).forEach(name => ngModule.component(name, module.components[name]));

  Object.keys(module.directives).forEach(name => ngModule.directive(name, module.directives[name]));

  Object.keys(module.services).forEach(name => ngModule.service(name, module.services[name]));

  Object.keys(module.filters).forEach(name => ngModule.filter(name, module.filters[name]));

  Object.keys(module.factories).forEach(name => ngModule.factory(name, module.factories[name]));

  module.configBlocks.forEach(configBlock => ngModule.config(configBlock));

  module.runBlocks.forEach(runBlock => ngModule.run(runBlock));

  return ngModule;
}





// WEBPACK FOOTER //
// ./src/app/bootstrap/ngmodule.ts